import { CasinoType } from 'modules/Casino/types/configuration';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { XPGGameData, XPGGameDataListResponse } from '../../types/interfaces/LiveCasino/XPGDTO';
import { IGetGameUrl } from '../../types/slot';

const xpgIMG = require('./img/xpg.jpg');
const baccaratIMG = require('./img/xpg-baccarat.png');
const blackJackIMG = require('./img/xpg-blackJack.png');
const rouletteIMG = require('./img/xpg-roulette.png');

const getImageByGameType = (gameType: string) => {
  switch (gameType) {
    case '1':
      return rouletteIMG;
    case '2':
      return blackJackIMG;
    case '4':
      return baccaratIMG;
    default:
      return xpgIMG;
  }
};

class XPGConverter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<XPGGameDataListResponse>): ISlotViewItem[] =>
    (data ?? []).map(
      (item: XPGGameData) =>
        ({
          id: item.gameID,
          gameId: item.gameID,
          gameName: item.gameName,
          provider: 'xpg',
          imageUrl: getImageByGameType(item.gameType),
          type: CasinoType.liveCasino,
          description: item.gameName,
          tab: [],
          routeProvider: 'xpg',
          limitSetID: item.limitSetList.limitSet.limitSetID,
        }) as ISlotViewItem,
    );

  convertGameUrl = ({ data }: IGetGameUrl<string, unknown>) => data;
}

export default XPGConverter;
